import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING_PAGE_COURSES_AVAILABLE } from "../../constants/text_constants";
import CourseCard from "./CourseCard";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import { useNavigate } from "react-router-dom";

const CoursesAvailableSection = ({ data }) => {
  const navigate = useNavigate();

  if (!data || data.length === 0) return null;

  const displayCards = data.slice(0, 6);

  return (
    <div>
      <SectionHeading
        heading={LANDING_PAGE_COURSES_AVAILABLE?.heading}
        subHeading={LANDING_PAGE_COURSES_AVAILABLE?.subHeading}
        headingColor="#130C40"
      />

<div className="mx-4 grid grid-cols-1 gap-5 sm:mx-0 sm:grid-cols-2 lg:grid-cols-3">
        {displayCards.map((ele, i) => (
          <CourseCard
            key={ele?.id || i}
            {...ele}
          />
        ))}
      </div>

      {data.length > 2 && (
        <div className="mt-6 flex justify-center">
          <button
            className="
              rounded-full
              bg-gradient-to-r
              from-cyan-400
              to-purple-600
              px-5
              py-1
              text-lg
              font-bold
              text-white
              shadow-lg
              transition-all
              hover:-translate-y-1
              hover:shadow-2xl
            "
            onClick={() => {
              navigate(UNPROTECTED_ROUTES.coursesAll);
            }}
          >
            View All Courses
          </button>
        </div>
      )}
    </div>
  );
};

export default CoursesAvailableSection;